import { useQuery } from '@tanstack/react-query';

import { indexWorkflows, workflowQueryKeys } from 'services/api/workflows';

// The inbox polls so newly-created runs and evaluator-settled statuses appear
// without a refresh (Phase 0; WebSockets are Phase 2). Same swap-point story as
// useWorkflow — replace the query block with a subscription later.
const LIST_POLL_INTERVAL_MS = 5000;

/**
 * The list data hook for the Inbound Referrals inbox. Fetching lives here so the
 * page is agnostic to how fresh data arrives.
 */
export default function useWorkflows() {
  const query = useQuery({
    queryKey: workflowQueryKeys.list,
    queryFn: ({ signal }) => indexWorkflows(signal),
    refetchInterval: LIST_POLL_INTERVAL_MS,
    refetchIntervalInBackground: true,
  });

  return {
    workflows: query.data ?? [],
    isLoading: query.isPending,
    isError: query.isError,
    refetch: query.refetch,
  };
}
